



























































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import MembersMemberDetails from "../members/MembersMemberDetails.vue";

import MemberJson from "../../shared/MemberJson";
import MembershipTermJson from "../../shared/MembershipTermJson";
import { MembershipTypeNames } from "../../shared/MembershipType";
import { MembershipRenewIntervalNames } from "../../shared/MembershipRenewInterval";
import PaymentExportInfoJson from "../../shared/PaymentExportInfoJson";
import { PaymentExportType } from "../../shared/PaymentExportType";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import SettingsJson from "../../shared/SettingsJson";
import SettingsNotificationsJson from "../../shared/SettingsNotificationsJson";

export default Vue.extend({
  name: "GroupsPayments",
  components: {
    Loading,
    MembersMemberDetails,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    settingsNotifications: Object as PropType<SettingsNotificationsJson>,
    appFrameClickedButton: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      showDetails: false,
      UserPermissionRank: UserPermissionRank,
      MembershipTypeNames: MembershipTypeNames,
      MembershipRenewIntervalNames: MembershipRenewIntervalNames,
      paymentExportMemberships: null as { term: MembershipTermJson; member: MemberJson }[] | null,
      exportedMemberships: null as PaymentExportInfoJson[] | null,
      selectedMemberId: null as number | null,
      detailsMode: "read",
      isExporting: false,
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  methods: {
    /*** START: details view ***/
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.loadData();
      }
    },

    openDetails(item: MemberJson | null, mode: string) {
      if (item != null) {
        this.selectedMemberId = item.ID;

        this.detailsMode = mode;
        this.toggleDetails();
      }
    },
    /*** END: details view ***/

    loadData() {
      this.loadMembersToExport();
      this.loadExportedMembers();
    },

    async loadMembersToExport() {
      this.paymentExportMemberships = null;
      if (this.restClient != null) {
        try {
          this.paymentExportMemberships = await this.restClient.getMembershipsReadyForPaymentExport();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadExportedMembers() {
      this.exportedMemberships = null;
      if (this.restClient != null) {
        try {
          this.exportedMemberships = await this.restClient.getRecentPaymentExports(PaymentExportType.memberships);
        } catch (e) {
          alert(e.message);
        }
      }
    },

    //export payment data
    async exportPaymentData() {
      this.isExporting = true;

      try {
        var exportInfo = await this.restClient.exportPaymentsForMemberships();
        if (exportInfo != null) {
          this.downloadPaymentData(exportInfo);
        } else {
          this.isExporting = false;
          alert("Aktuell sind keine Zahlungsdaten zum Export bereit.");
        }
      } catch (e) {
        this.isExporting = false;
        alert(e.message);
      }
    },

    async downloadPaymentData(downloadInfo: PaymentExportInfoJson) {
      this.isExporting = true;

      try {
        var data = await this.restClient.downloadPaymentExportFile(downloadInfo);
        if (data != null) {
          let atag = document.createElement("a");
          atag.style.display = "none";
          document.body.appendChild(atag);

          let blob = new Blob([data], { type: "octet/stream" });
          let url = window.URL.createObjectURL(blob);

          atag.href = url;
          atag.download = "payment_" + DateFormatter.formatFilenameDateTime(new Date(downloadInfo.dateTime)) + ".zip";
          atag.click();
          window.URL.revokeObjectURL(url);

          this.isExporting = false;
          this.loadData();
        }
      } catch (e) {
        this.isExporting = false;
        alert(e.message);
      }
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {},
});
